<script setup>
import CalculatorSubtitle from './CalculatorSubtitle.vue';
import CalculatorTitle from './CalculatorTitle.vue';
import PriceInfo from './PriceInfo.vue';
</script>

<template>
  <div class="cloud-calculator__header">
    <div class="cloud-calculator__header-main">
      <CalculatorTitle/>
      <CalculatorSubtitle/>
    </div>
    <div class="cloud-calculator__header-sidebar">
      <PriceInfo/>
    </div>
  </div>
</template>
